import React from 'react';

import WithDrawTransaction from './WithDrawTransaction';

import css from './style.module.scss';

const WithdrawModal: React.FC = () => (
  <div className={css.withdrawModal}>
    <WithDrawTransaction />
  </div>
);

export default WithdrawModal;
